"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _qs = _interopRequireDefault(require("qs"));
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _Translations = require("./Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
_axios.default.interceptors.request.use(function (config) {
  if (!config.public) {
    var token = localStorage.getItem('authentication_token');
    if (token) {
      config.headers.Authorization = token;
    }
  }
  config.paramsSerializer = function (params) {
    return _qs.default.stringify(params, {
      arrayFormat: 'repeat'
    });
  };

  // send locale by "Accept-Language" because we use stateless api in the backend
  var cookies = new _universalCookie.default();
  var locale = cookies.get('pll_language') || _Translations.DEFAULT_LANGUAGE;
  config.headers['Accept-Language'] = locale;
  return config;
});
var _default = _axios.default;
exports.default = _default;